export default __webpack_public_path__ + "static/media/addUserWhite.83f5f673.svg";